<template>
  <div
    class="zjxLogin"
    :style="{ backgroundImage: 'url(' + `${basicInfo.navBackground}` + ')' }"
  >
    <div class="zxj_login">
      <div class="zxj_background">
        <p class="zxj_p1">助推项目管理创新 成就每一位建造师</p>
        <p class="zxj_p2" style="">面向市场、立足行业、研究为主、服务立本</p>
      </div>
      <div class="loginQrcode">
        <div class="zxj_login__view">
          <p class="zxj_login__viewP">{{ `${isVip}` }}登录</p>
          <div class="zxj_login__viewInput">
            <el-input v-model="username" :placeholder="placeValue"></el-input>
          </div>

          <!-- 会员登录使用密码 -->
          <div class="zxj_login__viewInput" v-if="vipShow">
            <el-input
              type="password"
              @keydown.enter.native="loginUser"
              v-model="password"
              placeholder="请输入密码"
            >
            </el-input>
          </div>

          <!-- 非会员登录使用验证码 -->
          <div class="zxj_login__viewInput" style="display: flex" v-else>
            <el-input
              type="password"
              @keydown.enter.native="loginUser"
              v-model="phoneCode"
              placeholder="请输入验证码"
            >
            </el-input>
            <el-button
              class="specil_button"
              @click="sendPhoneMsg"
              :disabled="isDisabled"
            >
              {{ sendMsg }}
            </el-button>
          </div>

          <div>
            <el-button class="zxj_login__viewBtn" @click="checkLogin"
              >登录</el-button
            >
            <div class="zxj_login__register">
              <p>
                <!-- 没有账号，<span class="login_colorP" @click="zjx_register"
                  >注册会员</span
                > -->
              </p>
              <div style="display: flex">
                <p class="login_colorP" @click="zjx_forgetPassword">忘记密码</p>
                <p
                  class="login_colorP"
                  @click="operatingManual"
                  style="margin-left: 10px"
                >
                  操作手册
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="zxj_p3">
          <img
            src="@/assets/img/webIndex/phoneQRcode.png"
            style="width: 170px"
            alt=""
          />
          <p class="zxj_p4">扫码访问手机端</p>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      title="前往个人会员登录入口"
      :visible.sync="dialogVisible"
      :width="activeWidth"
      :before-close="handleClose"
    >
      <span style="color: red">{{ errorMSG }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="background-color: #c22c25; border: none"
          @click="handleClose"
        >
          个人会员登录入口
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { noMemberLogin, sendPhoneMsg } from "@/api/moudles/activities.js";
import {
  getBasicInfo,
  loginUser,
  getList,
  getNoVipList,
  getNavList,
} from "../../api/moudles/user.js";
import { getGuide } from "@/api/moudles/home.js";
import { vaildate } from "@/utils/validate.js";
export default {
  data() {
    return {
      frontUrl: "",
      errorMSG: "",
      basicInfo: {},
      activeWidth: "30%",
      dialogVisible: false,
      isMember: "",
      username: "",
      password: "",
      phoneCode: "",
      placeValue: "请输入手机号码",
      isVip: "",
      vipShow: true,
      disable: false,
      isDisabled: false,
      newNum: 60,
      sendMsg: "发送验证码",
      urlBack: "",
      videoBack: false,
      videoId: "",
      freeTime: "",
    };
  },
  created() {
    const { isMember } = this.$route.query;
    // console.log("this.urlBack", this.$route.query);
    if (this.$route.query && this.$route.query.detail) {
      this.urlBack = this.$route.query.detail;
    }
    if (this.$route.query && this.$route.query.videoDetail) {
      this.videoBack = true;
      this.videoId = this.$route.query.videoId;
      this.freeTime = this.$route.query.freeTime;
    }
    this.getFrontUrl();
    // this.isMember = isMember;
    // if (meetingCode) {
    //   this.meetingCode = meetingCode;
    // }
    if (isMember === undefined || isMember === "true") {
      // 个人会员登录
      this.isVip = "";
      this.placeValue = "请输入手机号码";
      this.vipShow = true;
    } else {
      // console.log('非会员啊')
      this.isVip = "非个人会员";
      this.placeValue = "请输入手机号码";
      this.vipShow = false;
    }
    // 非会员
    if (this.$store.state.user.noVipPhone) {
      return;
    }
    if (this.$store.state.user.token) {
      this.$router.replace("/home");
    }
  },
  mounted() {
    const screenWidth = window.screen.width;
    if (screenWidth < 760 && this.$route.name == "login") {
      this.$router.replace({
        name: "phoneLogin",
        query: this.$route.query,
      });
    }
    if (screenWidth > 760 && this.$route.name == "phoneLogin") {
      this.$router.replace({
        name: "login",
        query: this.$route.query,
      });
    }
    if (this.$phoneSize()) {
      this.activeWidth = "98%";
    } else {
      this.activeWidth = "30%";
    }
    this.getNavList();
  },
  methods: {
    async getFrontUrl() {
      await getGuide({
        data: {},
        success: (res) => {
          if (res.data && res.data.frontUrl) {
            this.frontUrl = res.data.frontUrl;
          }
        },
      });
    },
    // 打开操作手册
    operatingManual() {
      if (this.frontUrl) {
        window.open(this.frontUrl);
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.isVip = "";
      this.placeValue = "请输入手机号码";
      this.vipShow = true;
    },
    // 导航栏
    async getNavList() {
      await getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          const indexCodeList = res.data[0].children;
          indexCodeList.forEach((item) => {
            if (item.label == "基本信息") {
              this.getBasicInfo(item.key);
            }
          });
        },
      });
    },
    // 获取基本信息
    async getBasicInfo(column_code) {
      await getBasicInfo({
        data: {
          column_code,
        },
        success: (res) => {
          console.log("基本信息", res);
          this.basicInfo = res.data;
        },
      });
    },
    // 获取非会员消息列表
    async getNoVipList() {
      // console.log('非会员getlist')
      await getNoVipList({
        data: {
          pageNo: 1,
          pageSize: 10,
        },
        success: (res) => {
          const newArr = res.data;
          let newNum = 0;
          newArr.forEach((item) => {
            if (item.status != 1) {
              newNum++;
            }
          });
          this.$store.commit("user/SET_NOTICE_COUNT", parseInt(newNum));
        },
      });
    },
    // 获取消息列表
    async getList() {
      // console.log('会员getlist')
      await getList({
        data: {
          pageNo: 1,
          pageSize: 10,
        },
        success: (res) => {
          const newArr = res.data;
          let newNum = 0;
          newArr.forEach((item) => {
            if (item.status != 1) {
              newNum++;
            }
          });
          this.$store.commit("user/SET_NOTICE_COUNT", parseInt(newNum));
        },
      });
    },

    checkLogin() {
      if (this.vipShow) {
        this.loginUser();
      } else {
        this.noMemberLogin();
      }
    },
    // 非会员登录
    async noMemberLogin() {
      const params = {
        phone: this.username.trim(),
        phoneCode: this.phoneCode,
      };
      if (!vaildate.isPhone(params.phone)) {
        this.$message.error("请检查手机号输入是否正确");
        return;
      }
      if (!params.phoneCode) {
        this.$message.error("请输入手机验证码");
        return;
      }
      await noMemberLogin({
        data: params,
        success: (res) => {
          console.log("非会员登录", res);
          if (res.code === 200 || res.code === 0) {
            this.$message.success(res.msg);
            this.$store.commit("user/SET_VIP_STATUS", false);
            this.$store.commit("user/SET_TOKEN", res.data.accessToken);
            this.$store.commit("user/SET_TOKEN_TIME", Date.now());
            this.$store.commit("user/SET_NOVIP_PHONE", params.phone);
            if (this.urlBack) {
              setTimeout(() => {
                this.$router.push({
                  name: "ifirameView",
                  params: {
                    url: this.urlBack,
                    code: "",
                  },
                });
              }, 800);
            }
            // setTimeout(() => {
            //   this.getNoVipList();
            // });
            // if (window.screen.width < 760) {
            //   this.$router.replace({
            //     name: "phoneActivitiesDetail",
            //     params: {
            //       code: this.meetingCode,
            //       status: "back",
            //     },
            //   });
            // } else {
            //   this.$router.replace({
            //     name: "activitiesDetail",
            //     params: {
            //       code: this.meetingCode,
            //       status: "back",
            //     },
            //   });
            // }
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 发送注册短信
    async sendPhoneMsg() {
      if (this.disable) {
        this.$message.error(
          "短信验证码5分钟内只能发送一条，30分钟内有效，如果长时间未收到，请查看是否被短信拦截"
        );
        return;
      }
      if (!vaildate.isPhone(this.username)) {
        this.$message.error("请检查手机号输入是否正确");
        return;
      }
      await sendPhoneMsg({
        data: {
          mobile: this.username.trim(),
        },
        success: (res) => {
          if (res.code == 100) {
            this.errorMSG = res.msg;
            this.dialogVisible = true;
            return;
          }
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.disable = true;
            setTimeout(() => {
              this.disable = false;
            }, 300000);

            this.sendMsg = "60s";
            this.isDisabled = true;
            let newInerl = setInterval(() => {
              this.sendMsg = this.newNum-- + "s";
            }, 1000);
            setTimeout(() => {
              this.newNum = 60;
              clearInterval(newInerl);
              this.sendMsg = "重新发送";
              this.isDisabled = false;
            }, 59000);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 忘记密码
    zjx_forgetPassword() {
      if (window.screen.width < 760) {
        this.$router.push("/phoneIndex/forgetpassword");
      } else {
        this.$router.push("/forgetpassword");
      }
    },
    // 注册
    zjx_register() {
      if (window.screen.width < 760) {
        this.$router.push("/phoneIndex/register");
      } else {
        this.$router.push("/register");
      }
    },
    async loginUser() {
      if (!this.username) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      await loginUser({
        data: {
          phone: this.username,
          password: this.password,
        },
        success: (res) => {
          if (res.code == 0 || res.code == 200) {
            if (res.data.step !== 5) {
              this.$message.success("请完成所有注册流程");
              localStorage.setItem(
                "stepMember",
                JSON.stringify(res.data.member)
              );
              localStorage.setItem("stepCert", JSON.stringify(res.data.cert));
              localStorage.setItem("stepPay", JSON.stringify(res.data.pay));
              this.zjx_register();
            } else {
              this.$store.commit("user/SET_VIP_STATUS", true);
              this.$message.success(res.msg);
              this.$store.commit("user/SET_TOKEN", res.data.accessToken);
              this.$store.commit("user/SET_TOKEN_TIME", Date.now());
              localStorage.setItem("tokenTime", Date.now());
              this.$store.dispatch("user/GET_USERINFO");

              setTimeout(() => {
                this.getList();
              });
              // if (this.isMember == false || this.isMember == true) {
              //   if (!this.meetingCode) {
              //     const backUrl = this.$phoneSize()
              //       ? "phoneActivitiesDetail"
              //       : "activitiesDetail";
              //     this.$router.replace({
              //       name: backUrl,
              //     });
              //   } else {
              //     if (this.$phoneSize()) {
              //       this.$router.replace({
              //         name: "phoneActivitiesDetail",
              //         params: {
              //           code: this.meetingCode,
              //           status: "back",
              //         },
              //       });
              //     } else {
              //       this.$router.replace({
              //         name: "activitiesDetail",
              //         params: {
              //           code: this.meetingCode,
              //           status: "back",
              //         },
              //       });
              //     }
              //   }
              //   return;
              // }
              if (this.urlBack) {
                setTimeout(() => {
                  this.$router.push({
                    name: "ifirameView",
                    params: {
                      url: this.urlBack,
                      code: "",
                    },
                  });
                }, 800);
              } else if (this.videoBack) {
                setTimeout(() => {
                  this.$router.push({
                    name: "videoplay",
                    params: {
                      video_id: this.videoId,
                      freeTime: this.freeTime,
                      isVip: true,
                      video: true,
                    },
                  });
                }, 800);
              } else {
                if (window.screen.width < 760) {
                  this.$router.push("/phoneMy");
                } else {
                  this.$router.push("/home");
                }
              }
            }
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.zxj_p1 {
  font-size: 45px;
  font-weight: 700;
  color: #333;
  font-family: Microsoft YaHei;
}
.zxj_p2 {
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 50px;
  margin-left: 2px;
  line-height: 2rem;
  color: #333;
  opacity: 0.9;
}

.zxj_p4 {
  text-align: center;
  margin-top: 2rem;
  font-size: 1.2rem;
  font-family: Microsoft YaHei;
  font-weight: 700;
  margin-bottom: 0.67rem;
}
@media screen and (max-width: 750px) {
  .loginQrcode {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .zjxLogin {
    min-height: 610px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: none !important;
  }
  .zxj_p3 {
    display: none;
  }
  .zxj_login {
    width: 100%;
    height: 550px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .zxj_background {
    display: none;
    /* width: 100%;
      height: 500px;
      object-fit: cover; */
  }

  .zxj_login__view {
    margin-top: 70px;
    position: absolute;
    width: 90%;
    margin-left: 5%;
    padding-bottom: 50px;
    border: 1px solid antiquewhite;
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .zxj_login__viewP {
    width: 100%;
    box-sizing: border-box;
    margin: 30px 0;
    padding-left: 55px;
    font-size: 20px;
    display: inline-block;
    height: 50px;
    text-align: left;
    line-height: 50px;
    font-weight: 600;
  }

  .zxj_login__viewInput {
    margin-bottom: 40px;
    width: 300px;
    height: 40px;
  }
}

@media screen and (min-width: 750px) {
  .loginQrcode {
    display: flex;
  }
  .zjxLogin {
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .zxj_p3 {
    width: 300px;
    background-color: #fff;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  .zxj_login {
    width: 100%;
    height: calc(100vh - 260px);
    /* background-color: #fff; */
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .zxj_background {
    height: 130px;
  }

  .zxj_login__view {
    width: 350px;
    height: 370px;
    border: 1px solid antiquewhite;
    display: flex;
    background-color: #fff;
    flex-flow: column;
    align-items: center;
  }

  .zxj_login__viewP {
    width: 352px;
    margin: 25px 0;
    padding-left: 55px;
    font-size: 20px;
    display: inline-block;
    height: 50px;
    text-align: left;
    line-height: 50px;
    font-weight: 600;
  }

  .zxj_login__viewInput {
    margin-bottom: 40px;
    width: 300px;
    height: 40px;
  }
}

>>> .el-input__inner {
  opacity: 0.7;
}

.zxj_login__viewBtn {
  width: 300px;
  height: 40px;
  background-color: #c22c25;
  color: #fff;
}

.zxj_login__register {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.login_colorP {
  color: #c22c25;
  cursor: pointer;
}
</style>
